import Logger from "../../../../utils/Logger";
import data1 from "../json/OfferingJsonData.json";
export const fetchAcademyData = async () => {
  try {
    const response = await fetch("https://your-api.com/techData.json");
    if (!response.ok)
      throw new Error(`API failed with status: ${response.status}`);

    const data = await response.json();
    return data;
  } catch (err) {
    console.warn("⚠️ API failed, using fallback local JSON. Error:", err);
    try {
      const localData = await fetch("/techData.json");
      if (!localData.ok)
        throw new Error(`Local JSON failed with status: ${localData.status}`);
      const fallbackData = await localData.json();
      return fallbackData;
    } catch (localErr) {
      console.error("❌ Failed to load both API and local JSON:", localErr);
      return null;
    }
  }
};
